import { Tooltip } from "@mui/material"
import {
  CancelFilledOutlined,
  ChangeCircleFilledOutlined,
  CheckCircleFilledOutlined,
  DoNotDisturbOnFilledOutlined,
} from "@mui-symbols-material/w300"
import type { FC } from "react"

import { ProductTestResultStatus } from "@/graphql/codegen/graphql"
import colors from "@/styles/colors"

interface Props {
  status: ProductTestResultStatus
}

export const ProductTestResultStatusIndicator: FC<Props> = ({ status }) => {
  switch (status) {
    case ProductTestResultStatus.NoResults:
      return (
        <Tooltip title='No Results'>
          <DoNotDisturbOnFilledOutlined sx={{ fontSize: 24, color: colors.grey[400] }} />
        </Tooltip>
      )
    case ProductTestResultStatus.ResultsWithinSpec:
      return (
        <Tooltip title='Results within spec'>
          <CheckCircleFilledOutlined sx={{ fontSize: 24, color: colors.tertiary.green[500] }} />
        </Tooltip>
      )
    case ProductTestResultStatus.UpdatedResultsWithinSpec:
      return (
        <Tooltip title='Updated Results within spec'>
          <ChangeCircleFilledOutlined sx={{ fontSize: 24, color: colors.tertiary.green[500] }} />
        </Tooltip>
      )
    case ProductTestResultStatus.ResultsNotWithinSpec:
      return (
        <Tooltip title='Results not within spec'>
          <CancelFilledOutlined sx={{ fontSize: 24, color: colors.secondary.main }} />
        </Tooltip>
      )
    default:
      return "-"
  }
}
